const utils = require('frontend-controller/lib/utils')

module.exports = {
	forceScope: 'art_form', // TODO: forceScope necessary since scope rework?

	config: {
		staticLookupName: 'artFormController'
	},

	model: {},

	methods: {
		showEdit: function(type, entityID, entityData, refreshExistingTab, tabStrip, tabRegisterSecret){
			var self = this;
			var entityAttributes = (entityData || {}).attributes || {};
			var entityPrefix = '';
			var entityTitle = '';
			var entityIcon = '';
			var performActionGranted = false;
			var baseActionKey = 'showEdit_' + (type || '');
			var actionSuffix = '';
			var afterActionCallback;

			if(type === 'address'){
				performActionGranted = true;
				entityPrefix = storage.__('addresses.tabs.title.prefix.' + (entityAttributes.addressType || 'default'));
				entityIcon = 'fi fi-address-type';
				if(entityAttributes.addressType) 	entityIcon += '-' + entityAttributes.addressType;
				if(entityAttributes.addressTitle) 	entityTitle = entityAttributes.addressTitle;
				else  								entityTitle = ((entityAttributes.lastName || '') + ' ' + (entityAttributes.firstName || ''));
				actionSuffix = entityID;
			}
			if(this.hasRoleOption('showIDs', 'art_form')){
				entityPrefix = '#' + entityID + ' - ' + entityPrefix;
			}


			if(performActionGranted && refreshExistingTab && tabStrip && tabRegisterSecret !== undefined){
				performActionGranted = false;

				var actionKey, action, wasInsertAction = false;
				for(actionKey in self.actions){
					if(
						(action = self.actions[actionKey]) &&
						(
							(wasInsertAction = (action.originalActionKey === ('showInsert_' + type))) ||
							action.originalActionKey === ('showEdit_' + type)
						) &&
						(action.tabConnection || {}).tabRegisterSecret === tabRegisterSecret &&
						action.tabConnection.tabStripComponentIndex === tabStrip.componentIndex
					){
						if(wasInsertAction) {
							performActionGranted = true;
							tabStrip.hideTab(tabRegisterSecret);
							afterActionCallback = function(){
								tabStrip.removeTab(tabRegisterSecret);
							}
						} else {
							tabStrip.refreshTab(tabRegisterSecret, {
								title: 	entityPrefix + ': ' + entityTitle,
								icon: 	entityIcon
							}, true);
						}
						break;
					}
				}
			}

			if(performActionGranted){
				if(self.actions[baseActionKey]){
					return self.performAndStoreAction(
						baseActionKey + '_inEffect_' + actionSuffix,
						self.prepareAction(baseActionKey, undefined, {
							entity: 	{ resourceID: entityID },
							relation: 	{
								entityID,
								activityYear: self.model.activityYear
							},
							tabOptions: {
								title: 	entityPrefix + ': ' + entityTitle,
								icon: 	entityIcon
							}
						})
					).then(function(context){
						if(afterActionCallback){
							return afterActionCallback();
						}
					});
				}
			}

			return utils.promise.reject();
		}
	}
}